export default class Insights {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.images = this.element.querySelectorAll(`${element}__image`);
        this.arrows = this.element.querySelectorAll(`${element} svg`);
        this.counter = 0;
        this.bindEvents();
        this.init();
    }

    init() {
        this.images.forEach((image, i) => {
            if (i == 0) {
                image.classList.add("insights__image--active");
                this.animSlideIn(image);
            } else {
                this.animSlideOut(image, 0);
            }
        });
    }
    bindEvents() {
        this.arrows.forEach(item => {
            item.addEventListener("click", e => this.switchImage(e));
        });
    }
    animSlideOut(element, duration = 0.8) {
        TweenMax.to(element, duration, {
            x: -10,
            autoAlpha: 0,
            ease: Power3.easeInOut
        });
    }

    animSlideIn(element, duration = 0.8) {
        TweenMax.set(element, { x: 10 });
        TweenMax.to(element, duration, {
            x: 0,
            autoAlpha: 1,
            ease: Power3.easeInOut
        });
    }

    switchImage(e) {
        let arrow = e.currentTarget;

        if (arrow.dataset.direction == "left") {
            this.counter <= 0
                ? (this.counter = this.images.length - 1)
                : this.counter--;
        } else {
            this.counter >= this.images.length - 1
                ? (this.counter = 0)
                : this.counter++;
        }
        this.images.forEach(image => {
            image.classList.remove("insights__image--active");
            this.animSlideOut(image);
        });
        this.images[this.counter].classList.add("insights__image--active");
        this.animSlideIn(this.images[this.counter]);
    }
}
